// hooks/useIsMobile.ts
import { useEffect, useState } from "react";

export default function useIsMobile(breakpointPx = 992) { // matches Bootstrap lg
  const query = `(max-width: ${breakpointPx - 0.02}px)`;
  const [isMobile, setIsMobile] = useState(
    typeof window !== "undefined" ? window.matchMedia(query).matches : false
  );

  useEffect(() => {
    if (typeof window === "undefined") return;
    const mq = window.matchMedia(query);
    const handler = () => setIsMobile(mq.matches);
    handler();
    mq.addEventListener?.("change", handler);
    return () => mq.removeEventListener?.("change", handler);
  }, [query]);

  return isMobile;
}
